export default "__VITE_ASSET__DFn5Ru5u__"